/**
 * Pixel-perfect setup (TRD-03 §3).
 *
 * These are HARD constants. Nothing computes them from the DOM — the whole point of a
 * fixed logical resolution is that the game's layout is identical on every machine and
 * only the upscale factor varies.
 */
export const TILE_PX = 16;
export const MAP_COLS = 32;
export const MAP_ROWS = 18;

/** 32 × 18 tiles at 16 px. 16:9, and an exact integer multiple at every scale. */
export const LOGICAL_W = MAP_COLS * TILE_PX; // 512
export const LOGICAL_H = MAP_ROWS * TILE_PX; // 288

export const BACKGROUND = 0x0e0e10;

/** Tileset layout — must match `TILE` in @prism/content/autotile.ts. */
export const TILESET_COLS = 8;
export const TILE_INDEX = {
  VOID: 0,
  GROUND_FIRST: 1,
  PATH_FIRST: 5,
  BLOCKED_FIRST: 21,
  DECOR_FIRST: 37,
  SPAWN_FIRST: 45,
  CORE_FIRST: 49,
} as const;

/**
 * Integer upscale only (TRD-03 R-03-03).
 *
 * A fractional scale destroys the pixel grid, and with 16 px same-shape towers that is
 * instantly visible as shimmer. Better to letterbox than to blur.
 */
export function computeScale(viewportW: number, viewportH: number): number {
  return Math.max(1, Math.floor(Math.min(viewportW / LOGICAL_W, viewportH / LOGICAL_H)));
}
